import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../components/SeoHead";

export default function NotFound() {
  return (
    <>
      <SeoHead title="Siden blev ikke fundet (404)" description="Siden du leder efter findes desværre ikke." path="/404" />

      <section className="min-h-[70vh] flex items-center justify-center bg-[#FAF7F2] py-20 px-4">
        <div className="max-w-md w-full text-center space-y-6 sand-card-light p-8 sm:p-10 rounded-3xl border border-[#EADFCF] shadow-sm">
          <div className="w-16 h-16 rounded-full bg-[#EADFCF] text-[#6B5640] flex items-center justify-center mx-auto text-2xl font-bold font-mono">
            404
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl sm:text-3xl font-bold font-heading text-[#2C2523]">
              Siden blev ikke fundet
            </h1>
            <p className="text-sm text-[#5C524C]">
              Beklager, men den side du leder efter findes enten ikke mere eller er flyttet.
            </p>
          </div>

          <div className="pt-2">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#3A302B] hover:bg-[#231C19] text-[#FFFDF9] px-6 py-3 rounded-xl font-semibold text-sm transition-colors shadow-xs"
            >
              <i className="fa-solid fa-house text-xs" aria-hidden="true"></i>
              <span>Gå til forsiden</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
